import * as React from 'react';
import { LinkButton, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { useTheming } from './utils/useTheming';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DEFAULT_TITLE = 'Помощь надёжных риелторов';
var DEFAULT_TEXT = 'Риелтор партнёр Циан поможет купить или продать любую недвижимость';
var DEFAULT_BUTTON_TEXT = 'Оставить заявку';

//TODO ловушка в эксперименте ABCD, отпилить лишнюю темизацию, когда эксперимент закончится https://jira.cian.tech/browse/VAL-1626
export var RealtorRequestTrapV2 = function RealtorRequestTrapV2(props) {
  var _props$title = props.title,
    title = _props$title === void 0 ? DEFAULT_TITLE : _props$title,
    _props$text = props.text,
    text = _props$text === void 0 ? DEFAULT_TEXT : _props$text,
    _props$buttonText = props.buttonText,
    buttonText = _props$buttonText === void 0 ? DEFAULT_BUTTON_TEXT : _props$buttonText,
    variant = props.variant,
    className = props.className,
    onClick = props.onClick,
    href = props.href,
    openBlank = props.openBlank;
  var _useTheming = useTheming(variant, className),
    buttonTheme = _useTheming.buttonTheme,
    containerClassname = _useTheming.containerClassname;
  return /*#__PURE__*/_jsxs("div", {
    className: containerClassname,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['title'],
      children: /*#__PURE__*/_jsx(UIHeading1, {
        color: "current_color",
        children: title
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['text'],
      children: /*#__PURE__*/_jsx(UIText1, {
        color: "current_color",
        children: text
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['button'],
      children: /*#__PURE__*/_jsx(LinkButton, {
        theme: buttonTheme,
        href: href,
        onClick: onClick,
        target: openBlank ? '_blank' : undefined,
        "data-testid": "realtor_request_trap_link",
        children: buttonText
      })
    })]
  });
};
RealtorRequestTrapV2.displayName = 'RealtorRequestTrapV2';